export default "Leg los og tjur! Lad losserne prøve at liste sig ind på ”tjuren” uden at blive hørt!";